import { render } from "./themeView.vue?vue&type=template&id=489c23d6&scoped=true"
import script from "./themeView.vue?vue&type=script&lang=js"
export * from "./themeView.vue?vue&type=script&lang=js"

import "./themeView.vue?vue&type=style&index=0&id=489c23d6&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489c23d6"]])

export default __exports__